import { Injectable } from "@angular/core";
import {Location} from "@angular/common";
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean;
}

@Injectable()
export class IsChildPageGuard {
  constructor(private location:Location, private router: Router) { }

  canDeactivate(
    component: ComponentCanDeactivate,
    route: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ):  boolean {
    const nextStateStart = nextState.url.split('/').slice(1,3).join('/');
    const currentStateStateStart = currentState.url.split('/').slice(1,3).join('/');
    if (nextStateStart === currentStateStateStart) {
      setTimeout( () => {
        this.location.go(nextState.url);
      }, 0);
      return false;
    } else {
      return true;
    }
  }
}
